import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { User, UserGroup } from "../../../app/app.interfaces";
import { AuthService } from "../../../services/auth.service";
import { UserGroupService } from "../../../services/user-group.service";


@Component({
  selector: 'user-card',  
  templateUrl: 'user-card.html'  
})
export class UserCard implements OnInit, OnChanges {  
  @Input() user?: User;
  @Input() userGroup?: UserGroup;
  @Input() showUserGroup: boolean = false;
  @Input() anonymous: boolean = false;
  @Input() link: boolean = true;
  @Input() showSelf: boolean = true;
  @Input() size: string = 'regular';
  
  template: string = 'full';
  
  constructor(public authService: AuthService,
              private groupService: UserGroupService

  ){}

  ngOnChanges(changes: SimpleChanges): void {
    this.setTemplate();
    if((!! changes.user && ! changes.user.firstChange) || (!! changes.showUserGroup && ! changes.showUserGroup.firstChange)) {
      this.setUserGroup();
    }
  }

  ngOnInit(): void {
    this.setTemplate();

    if(this.showUserGroup) {
      this.setUserGroup();
    }
  }

  private async setUserGroup() {
    if(this.user && this.user.userGroup) {
      this.userGroup = await this.groupService.getAsync(this.user.userGroup);
    }
  }
  
  private setTemplate(){        
    if(!this.anonymous){
      this.template = 'full';      
      if(this.showSelf && this.user && this.user.id === this.authService.user.id) {
        this.template = 'self';        
      }      
    }
    else {
      
      this.link = false;
      
      if(this.showSelf && this.user && this.user.id === this.authService.user.id) {
        this.template = 'anonymous_self';
      }
      else if(this.authService.user.admin){
        this.template = 'anonymous_admin';
      }
      else {
        this.template = 'anonymous'
      }
    }
    
  }
  
  
  
}



// WEBPACK FOOTER //
// ./src/partials/user/user-card/user-card.ts